import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  postComments: [],
};

const postCommentsSlice = createSlice({
  name: "postComments",
  initialState,
  reducers: {
    updatePostComments: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

// Export the actions generated by `createSlice`
export const { updatePostComments } = postCommentsSlice.actions;

// Export the reducer from the generated slice
export default postCommentsSlice.reducer;
